var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProposta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.13,
    height: 24.723,
    viewBox: "0 0 18.13 24.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "proposta",
    d: "M33.482,11.126V6.648A1.653,1.653,0,0,0,31.834,5H18.648A1.653,1.653,0,0,0,17,6.648V24.229a1.653,1.653,0,0,0,1.648,1.648H30.735v.549a.464.464,0,0,0,.082.275l1.648,2.747a.534.534,0,0,0,.934,0L35.048,26.7a.53.53,0,0,0,.082-.275V13.241A2.184,2.184,0,0,0,33.482,11.126Zm-2.747,2.115V24.778H18.648a.551.551,0,0,1-.549-.549V6.648a.551.551,0,0,1,.549-.549H31.834a.551.551,0,0,1,.549.549v4.478A2.184,2.184,0,0,0,30.735,13.241Zm3.3,13.048-1.1,1.84-1.1-1.84V15.439h2.2Zm0-11.949h-2.2v-1.1a1.1,1.1,0,1,1,2.2,0ZM19.747,8.3a.551.551,0,0,1,.549-.549h4.4a.549.549,0,0,1,0,1.1H20.3A.551.551,0,0,1,19.747,8.3Zm9.34,14.284a.551.551,0,0,1-.549.549h-4.4a.549.549,0,0,1,0-1.1h4.4A.551.551,0,0,1,29.087,22.581Zm0-11.537a.551.551,0,0,1-.549.549H20.3a.549.549,0,1,1,0-1.1h8.241A.551.551,0,0,1,29.087,11.043Zm0,2.747a.551.551,0,0,1-.549.549H20.3a.549.549,0,1,1,0-1.1h8.241A.551.551,0,0,1,29.087,13.79Z",
    transform: "translate(-17 -5)",
    fill: "#640000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposta);
export default __webpack_public_path__ + "static/media/proposta.3fedec30fa221c9911e059885b3f279f.svg";
export { ForwardRef as ReactComponent };